import {ServiceClass} from '@/decorators';
import {ReportModel} from '../models';
import {PaginationResponseModel, PaginationViewModel} from '../models/common';
import {BaseApi} from './base.api';

@ServiceClass()
export class ReportsApi extends BaseApi {
    public getReports(siteId: string, filter?: PaginationViewModel<ReportModel>) {
        return this.GET_RequestAsync<PaginationResponseModel<ReportModel>>(`${this.ApiUrl}/reports/${siteId}?filter=${JSON.stringify(filter)}`);
    }

    public getReportsStatistics(siteId: string) {
        return this.GET_RequestAsync<any>(`${this.ApiUrl}/reports/${siteId}/statistics`);
    }

    public deleteReport(reportId: string) {
        return this.DELETE_RequestAsync(`${this.ApiUrl}/reports/${reportId}`);
    }

    public generateSiteInformationReport(siteId: string, data: any) {
        return this.POST_RequestAsync<any>(`${this.ApiUrl}/reports/site-information-report/${siteId}`, data);
    }

    public generateAreaReport(siteId: string, areaId: string | undefined, isSave: boolean = false) {
        return this.downloadRequest<any>(
            `${this.ApiUrl}/reports/area-report/${siteId}?isSave=${isSave}${areaId ? '&areaId=' + encodeURIComponent(areaId) : ''}`
        );
    }

    public generateInspectionReport(siteId: string, equipmentId: string | undefined, inspectionId: string | undefined, isSave: boolean = false) {
        return this.downloadRequest<any>(
            `${this.ApiUrl}/reports/inspection-report/${siteId}?isSave=${isSave}${equipmentId ? '&equipmentId=' + encodeURIComponent(equipmentId) : ''}${
                inspectionId ? '&inspectionId=' + encodeURIComponent(inspectionId) : ''
            }`
        );
    }

    public generateInspectionReportExd(siteId: string, isSave: boolean = false) {
        return this.downloadRequest<any>(`${this.ApiUrl}/reports/inspection-report/${siteId}/ex-d?isSave=${isSave}`);
    }

    public generateInspectionReportExi(siteId: string, isSave: boolean = false) {
        return this.downloadRequest<any>(`${this.ApiUrl}/reports/inspection-report/${siteId}/ex-i?isSave=${isSave}`);
    }

    public generateInspectionReportExp(siteId: string, isSave: boolean = false) {
        return this.downloadRequest<any>(`${this.ApiUrl}/reports/inspection-report/${siteId}/ex-p?isSave=${isSave}`);
    }

    public generateEquipmentReport(siteId: string, equipmentId: string | undefined, isSave: boolean = false) {
        return this.downloadRequest<any>(
            `${this.ApiUrl}/reports/equipment-report/${siteId}?isSave=${isSave}${equipmentId ? '&equipmentId=' + encodeURIComponent(equipmentId) : ''}`
        );
    }

    public generateJunctionBoxReport(siteId: string, junctionBoxId: string | undefined, isSave: boolean = false) {
        return this.downloadRequest<any>(
            `${this.ApiUrl}/reports/junction-box-report/${siteId}?isSave=${isSave}${junctionBoxId ? '&junctionBoxId=' + encodeURIComponent(junctionBoxId) : ''}`
        );
    }

    public generatePeriodicReport(siteId: string, data: any) {
        return this.POST_RequestAsync<any>(`${this.ApiUrl}/reports/periodic-report/${siteId}`, data);
    }

    public generateIntrinsicSafetyReport(siteId: string, isSave: boolean = false) {
        return this.downloadRequest<any>(`${this.ApiUrl}/reports/intrinsic-safety-report/${siteId}?isSave=${isSave}`);
    }

    public async downloadReport(reportId: string) {
        return this.downloadRequest<Blob>(`${this.ApiUrl}/reports/${reportId}/download`);
    }

    public downloadEquipmentReport(locationId: string) {
        return this.downloadRequest<any>(`${this.ApiUrl}/reports/equipment-report/${locationId}`);
    }

    public async previewReport(reportId: string) {
        return this.downloadRequest<Blob>(`${this.ApiUrl}/reports/${reportId}/preview`);
    }

    public generateJobReport(siteId: string, projectId: string, data: any) {
        return this.POST_RequestAsync<any>(`${this.ApiUrl}/reports/job-report/${siteId}/${projectId}`, data);
    }
}
